import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useMediaQuery, createBreakpoints } from 'WeployDesignLanguage/mediaQueries';

import Button from 'WeployDesignLanguage/buttons/Button';
import {
  ApprovedTimesheets as ApprovedTimesheetsIllustration,
  HandHoldingPhone as HandHoldingPhoneIllustration,
  Invoice as InvoiceIllustration,
  CreditCard as CreditCardIllustration,
} from 'WeployDesignLanguage/illustrations';

import { getInternalPath, TIMESHEETS_NO_PARAMS_PATH } from '../../../containers/weployer/pathHelpers';


const ApprovalSuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${props => props.theme.spacing[1]};
  color: ${props => props.theme.colors.text.primary};
  width: 100%;
`;

const StyledIconContainer = styled.div`
  margin: ${props => props.theme.spacing[3]} 0;
`;

const StyledSubtitle = styled.p`
  ${props => props.theme.typography.subtitle1};
`;

const StyledList = styled.div`
  padding-bottom: ${props => props.theme.spacing[4]};
`;

const StyledBullet = styled.div`
  display: flex;
  margin-bottom: ${props => props.theme.spacing[1]};
`;

const StyledExplanation = styled.span`
  margin-left: ${props => props.theme.spacing[2]};
`;

const StyledButtonWrapper = styled.div`
  margin: ${props => props.theme.spacing[1]} 0;
`;

const ApprovalSuccess = ({
  isInvoice,
  isCreditCard,
  onButtonClick,
}) => {
  const { DOWN_SM } = createBreakpoints();
  const mobileUser = useMediaQuery(DOWN_SM);

  return (
    <ApprovalSuccessWrapper>
      <h5>Timesheets approved{ isCreditCard && ' and paid' }, thanks!</h5>
      <StyledIconContainer>
        <ApprovedTimesheetsIllustration size={mobileUser ? '300' : '400'} />
      </StyledIconContainer>
      <div>
        <StyledSubtitle>Here&apos;s what happens next</StyledSubtitle>
        <StyledList>
          <StyledBullet>
            <HandHoldingPhoneIllustration />
            <StyledExplanation>Weployees will be paid within 10 business days</StyledExplanation>
          </StyledBullet>
          { isInvoice &&
            <StyledBullet>
              <InvoiceIllustration />
              <StyledExplanation>Invoices will be sent to your billing account email {isCreditCard && 'for any jobs set to invoice'}</StyledExplanation>
            </StyledBullet>
          }
          { isCreditCard &&
            <StyledBullet>
              <CreditCardIllustration />
              <StyledExplanation>Credit cards have been processed and receipts emailed {isInvoice && 'for any jobs set to credit card'}</StyledExplanation>
            </StyledBullet>
          }
        </StyledList>
      </div>
      <StyledButtonWrapper>
        <Button
          href={getInternalPath({ pathName: TIMESHEETS_NO_PARAMS_PATH })}
          onClick={onButtonClick}
        >
          BACK TO TIMESHEETS
        </Button>
      </StyledButtonWrapper>
    </ApprovalSuccessWrapper>
  );
};

ApprovalSuccess.propTypes = {
  isInvoice: PropTypes.bool,
  isCreditCard: PropTypes.bool,
  onButtonClick: PropTypes.func,
};

ApprovalSuccess.defaultProps = {
  isInvoice: true,
  isCreditCard: true,
  onButtonClick: () => {},
};

export default ApprovalSuccess;
